// src/components/AnkleOedema.js
import React from 'react';
import styled from '@emotion/styled';

const AnkleOedemaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const ContentBox = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 20px;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #C5C5C6;
  border-radius: 12px;
`;

const SelectGroup = styled.div`
  display: flex;
  gap: 24px;
`;

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.label`
  font-family: 'Sofia Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #2C2C2D;
`;

const Select = styled.select`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 18px 16px;
  gap: 10px;
  width: 250px;
  background: #FFFFFF;
  border: 1px solid #A7A7AA;
  border-radius: 12px;
  font-family: 'Sofia Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #2C2C2D;

  &::placeholder {
    color: #A7A7AA;
  }
`;

const AnkleOedema = ({ data, onChange }) => {
  const handleChange = (side, value) => {
    onChange({
      ...data,
      [side]: value
    });
  };

  const options = ['none', 'mild', 'moderate', 'severe'];

  return (
    <AnkleOedemaContainer>
      <ContentBox>
        <SelectGroup>
          {['left', 'right'].map((side) => (
            <SelectWrapper key={side}>
              <Label htmlFor={`ankle-oedema-${side}`}>{side.charAt(0).toUpperCase() + side.slice(1)}</Label>
              <Select
                id={`ankle-oedema-${side}`}
                value={data[side]}
                onChange={(e) => handleChange(side, e.target.value)}
              >
                {options.map((option) => (
                  <option key={option} value={option}>
                    {option.charAt(0).toUpperCase() + option.slice(1)}
                  </option>
                ))}
              </Select>
            </SelectWrapper>
          ))}
        </SelectGroup>
      </ContentBox>
    </AnkleOedemaContainer>
  );
};

export default AnkleOedema;
